import { AdminApiService } from '../services';

export const getMeta = async (): Promise<AppMetaType> => {
  const result = await AdminApiService.getCampaignsApiAdminCampaignsGet();

  return {
    campaigns: result
      .map(item => ({ value: item.id, label: item.name }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  };
};
